"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var CopyAPIResponse = function (_a) {
    var text = _a.text, subText = _a.subText, icon = _a.icon, loader = _a.loader;
    return (react_1["default"].createElement(box_1["default"], { style: {
            width: 552,
            flexDirection: 'column',
            alignItems: 'center',
            lineHeight: 1.5,
            padding: '2rem',
        } },
        loader ? react_1["default"].createElement(loader_1["default"], { themed: true }) : icon,
        react_1["default"].createElement("br", null),
        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, text),
        subText && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.deep" }, subText))));
};
exports["default"] = CopyAPIResponse;
